export function setLoggedIn(id: string, role: string) {
    localStorage.setItem("id", id);
    localStorage.setItem("role", role);
    localStorage.setItem("loggedIn", "true");
}